import Navbar from './components/Navbar/Navbar'
import Services from './components/Services/Services'
import Recommend from './components/Recommend/Recommend'
import Testimonials from './components/Testimonials/Testimonials'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'

function App() {
  return (
    < >
      <Navbar />
      <Header />
      <Services />
      <Recommend />
      <Testimonials />
      <Footer />
    </>
  );
}

export default App;
